module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.c169a715.svg";